// extracted by mini-css-extract-plugin
module.exports = {"icon":"mark-modal_icon__Lt0P8","contents":"mark-modal_contents__i6ryR","tips":"mark-modal_tips__1VLxx","errors":"mark-modal_errors__Y0MqH","error":"mark-modal_error__G6iDL"};